import React from 'react'
import Layout from '../components/layout/Layout'

export default function Summary() {
  return (
    <Layout>
      <h2>Management</h2>
    </Layout>
  )
}
